{
  "interface": "Interfaccia",
  "newInterface": "Nuova interfaccia",
  "updateInterface": "Modifica interfaccia",
  "generateNewInterface": "Genera una nuova interfaccia",
  "tabs": {
    "mobileApp": {
      "title": "Applicazione mobile",
      "column": {
        "organizationName": "Nome dell’organizzazione",
        "name": "Nome dell'interfaccia",
        "deviceTypes": "Tipo di dispositivo",
        "updatedAt": "Data dell’aggiornamento"
      },
      "form": {
        "information": {
          "title": "Informazioni",
          "organizationName": "Nome dell’organizzazione",
          "name": "Nome",
          "description": "Descrizione"
        },
        "deviceTypes": {
          "title": "Tipo di dispositivo",
          "label": "Modelli",
          "add": "Aggiungi",
          "save": "Salva",
          "cancel": "Annulla",
          "noLabel": "Tipo sconosciuto"
        },
        "validation": {
          "name": "Il nome dell’interfaccia è obbligatorio",
          "nameFormat": "Il nome dell’interfaccia può contenere solo caratteri alfanumerici o trattini bassi",
          "uniqueName": "Il nome dell’interfaccia deve essere univoco"
        }
      },
      "empty": "Nessuna applicazione mobile disponibile"
    },
    "thirdPartyApp": {
      "title": "Applicazioni di terze parti",
      "column": {
        "organizationName": "Nome dell’organizzazione",
        "interfaceName": "Nome dell’interfaccia",
        "authMethod": "Metodo di autenticazione",
        "profile": "Profilo",
        "updatedAt": "Data dell’aggiornamento",
        "status": "Stato"
      },
      "status": {
        "active": "Attivo",
        "inactive": "Inattivo"
      },
      "authMethod": {
        "clientGrant": "Client Grant",
        "mtls": "mTLS",
        "userCredentials": "Identificazione cliente"
      },
      "form": {
        "title": "Informazioni",
        "organizationName": "Nome dell’organizzazione",
        "name": "Nome dell’interfaccia",
        "profile": {
          "label": "Profilo",
          "placeholder": "Seleziona un profilo"
        },
        "sectors": {
          "label": "Reti",
          "placeholder": "Seleziona delle reti"
        },
        "authenticationType": {
          "label": "Tipo di autenticazione",
          "clientGrant": "ClientGrant",
          "mtls": "mTLS"
        },
        "validation": {
          "organizationName": "Il nome dell’organizzazione è obbligatorio",
          "name": "Il nome è obbligatorio",
          "profile": "Il profilo è obbligatorio",
          "sectors": "La selezione di una o più reti è obbligatoria",
          "authenticationType": "Il tipo di autenticazione è obbligatorio",
          "nameFormat": "Il nome dell’interfaccia può contenere solo caratteri alfanumerici o trattini bassi",
          "uniqueName": "Il nome dell’interfaccia deve essere univoco"
        },
        "update": {
          "sidePanelTitle": "Modifica dell’interfaccia di terze parti",
          "information": {
            "title": "Importante",
            "content": "Se hai perso il tuo client segreto, elimina questa interfaccia e creane una nuova"
          }
        },
        "confirmCancelUpdate": {
          "title": "Annulla l’aggiornamento dell’interfaccia",
          "message": "Vuoi davvero annullare l’aggiornamento dell’interfaccia?"
        },
        "confirmCancelCreate": {
          "title": "Annulla la creazione dell’interfaccia",
          "message": "Vuoi davvero annullare la creazione dell’interfaccia?"
        }
      },
      "creationModalSuccess": {
        "header": {
          "title": "Riuscita",
          "info": "Avvertenza: Conservare con cura queste informazioni, poiché non saranno più consultabili una volta chiusa la pagina."
        },
        "clientId": {
          "label": "ClientId"
        },
        "secret": {
          "label": "Segreto"
        },
        "copyToClipboard": {
          "copied": "Copiato",
          "buttonTitle": "copiare negli appunti"
        }
      },
      "empty": "Nessuna applicazione di terze parti disponibile",
      "licenseMessage": {
        "disableNewInterface": "È stato raggiunto il limite della licenza, la creazione di interfacce è disattivata.",
        "disableActivateInterface": "È stato raggiunto il limite della licenza, l’attivazione di interfacce è disattivata."
      }
    }
  },
  "action": {
    "delete": {
      "confirm": {
        "title": "Eliminare l’interfaccia",
        "message": "L’interfaccia {name} sarà eliminata."
      }
    },
    "deactivate": {
      "confirm": {
        "title": "Disattiva l’interfaccia",
        "message": "L’interfaccia {name} sarà disattivata."
      }
    },
    "activate": {
      "confirm": {
        "title": "Attiva l’interfaccia",
        "message": "L’interfaccia {name} sarà attivata."
      }
    }
  }
}
